import { useEffect, useRef } from 'react';

export function usePreviousProp(value: any) {
	const ref = useRef(undefined);
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
}
